 <template>
  <div class="ExpandableDetail">
    <details class="ExpandableDetail__Details" ref="root">
      <summary ref="summary" @click.stop="handleClick">
        <slot name="summary"></slot>
      </summary>

      <div ref="detail">
        <slot name="detail"></slot>
      </div>
    </details>
  </div>
</template>

<script>
export default {
  name: 'ExpandableDetail',

  animation: null,
  animationState: "idle", // 'shrinking', 'growing', or 'idle'

  methods: {
    handleClick(e) {
      const root = this.$refs.root
      root.style.overflow = 'hidden';
      if (this.$options.animationState == "shrinking" || !root.open) {
        this.open();
      } else if (this.$options.animationState == "growing" || root.open) {
        this.shrink();
      }
      e.preventDefault();
    },

    open() {
      const root = this.$refs.root

      root.style.height = `${root.offsetHeight}px`;
      root.open = true;
      window.requestAnimationFrame(() => this.grow());
    },

    shrink() {
      const root = this.$refs.root
      const summary = this.$refs.summary

      this.$options.animationState == 'shrinking'
      
      const startHeight = `${root.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight}px`;
      
      if (this.$options.animation) {
        this.$options.animation.cancel();
      }
      
      this.$options.animation = root.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 296,
        easing: 'ease-out'
      });
      
      this.$options.animation.onfinish = () => this.onAnimationFinish(false);
      this.$options.animation.oncancel = () => this.$options.animationState = 'idle';
    },

    grow() {
      this.$options.animationState = "growing"

      const startHeight = `${this.$refs.root.offsetHeight}px`;
      const endHeight = `${this.$refs.summary.offsetHeight + this.$refs.detail.offsetHeight}px`;
      
      if (this.$options.animation) {
        this.$options.animation.cancel();
      }
      
      this.$options.animation = this.$refs.root.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 296,
        easing: 'ease-out'
      });
      this.$options.animation.onfinish = () => this.onAnimationFinish(true);
      this.$options.animation.oncancel = () => this.$options.animationState = 'idle';
    },

    onAnimationFinish(open) {
      this.$refs.root.open = open;
      this.$options.animation = null;
      this.$options.animationState = 'idle'
      this.$refs.root.style.height = this.$refs.root.style.overflow = '';
    }
  }
}
</script>

<style lang="scss" scoped>

.ExpandableDetail__Details {
  cursor: pointer;
}

.ExpandableDetail__Details summary::marker {
  display: none;
}

.ExpandableDetail__Details > summary {
  list-style: none;
}

.ExpandableDetail__Details > summary::-webkit-details-marker {
  display: none;
}

.ExpandableDetail__Details summary::after {
  content: '▶';
  display: inline-block;
  transition: transform 0.3s ease-in-out;
}

details[open].ExpandableDetail__Details summary::after {
  transform: rotate(90deg);
}
</style> 
